"use client";

import { PropsWithChildren } from "react";
import { StaleVersionBanner } from "./StaleVersionBanner";
import { useStaleVersionCheck } from "@/hooks/release";
import { useSessionExpiredNoticeStore } from "@/store/sessionExpiredNoticeStore";

/**
 * Wrapper that mounts the stale-version detector and renders an Update
 * available banner when the loaded client bundle is older than the release
 * currently served by the server. Always renders children — the banner is
 * non-blocking.
 */
export function StaleVersionWrapper({ children }: PropsWithChildren) {
  const { isStale, dismiss, reload } = useStaleVersionCheck();
  // One floating notice at a time: the expired session outranks the update.
  const isSessionExpiredVisible = useSessionExpiredNoticeStore((state) => state.isVisible);

  return (
    <>
      {isStale && !isSessionExpiredVisible && <StaleVersionBanner onReload={reload} onDismiss={dismiss} />}
      {children}
    </>
  );
}
